import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAspectRatio34: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="aspect-ratio-3-4, portrait"><path d="M4.75 2.75H19.25V21.25H4.75V2.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconAspectRatio34;
